import { RadioButton } from "primereact/radiobutton";

function splitLabel(label: string) {
  // Split by newlines, trim, drop empties
  const lines = label
    .split("\n")
    .map((s) => s.trim())
    .filter(Boolean);
  const [lead, ...rest] = lines;
  // Treat lines starting with "• " or "- " as bullets; otherwise still use as bullet text
  const bullets = rest.map((l) => l.replace(/^([•-])\s*/, ""));
  return { lead, bullets };
}

export function OptionSelector({
  selectedAbnOption,
  setSelectedAbnOption,
  options,
}: {
  selectedAbnOption: string;
  setSelectedAbnOption: (option: string) => void;
  options: {
    label: string;
    value: string;
    title?: string;
  }[];
}) {
  return (
    <div className="flex flex-column gap-3">
      <p className="text-sm font-semibold dark-gray">Choose one option:</p>
      <div className="flex flex-column gap-3">
        {options.map((option) => {
          const { lead, bullets } = splitLabel(option.label);

          return (
            <div
              className="flex flex-row gap-2 border-1 border-round-md p-2 cursor-pointer"
              style={{ borderColor: "#e2e2e4" }}
              onClick={() => setSelectedAbnOption(option.value)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setSelectedAbnOption(option.value);
                }
              }}
            >
              <RadioButton
                key={option.value}
                value={option.value}
                onChange={(e) => setSelectedAbnOption(e.value)}
                checked={selectedAbnOption === option.value}
              />
              <div className="flex flex-column gap-2">
                {option.title && (
                  <p className="text-sm font-semibold highlighted">
                    {option.title}
                  </p>
                )}
                <label htmlFor={option.value} className="text-sm gray">
                  <span className="block">{lead}</span>
                  {bullets.length > 0 && (
                    <ul className="mt-2 pl-3" style={{ listStyle: "disc" }}>
                      {bullets.map((b, i) => (
                        <li key={i}>{b}</li>
                      ))}
                    </ul>
                  )}
                </label>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
